import Card from '@/components/Card/Card';
import Input from '@/components/Input/Input';
import { InputStates } from '@/components/Input/Input.types';
import styles from './LinkedBundleName.module.css';
import { LinkedBundleNameProps } from '../CreateLinkedBundles.types';

export const LinkedBundleName = (props: LinkedBundleNameProps) => {
  const { groupName, handleChange, inputError } = props;
  return (
    <div className={styles.stepOne}>
      <div className={styles.accordionContainer}>
        <Card>
          <div className={styles.widgetBody}>
            <div className={styles.inputContainer}>
              <Input
                id="linkedBundleName"
                label="Name New Parent Group"
                value={groupName}
                onChange={handleChange}
                subText={inputError || undefined}
                state={inputError !== '' ? InputStates.Error : undefined}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
